import { render, staticRenderFns } from "./MarketConfigV2.vue?vue&type=template&id=0a2a0a60&scoped=true&"
import script from "./MarketConfigV2.vue?vue&type=script&lang=js&"
export * from "./MarketConfigV2.vue?vue&type=script&lang=js&"
import style0 from "./MarketConfigV2.vue?vue&type=style&index=0&id=0a2a0a60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2a0a60",
  null
  
)

export default component.exports